import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';

import BillingTable from './BillingTable';
import { BILLING_COLUMNS } from '../../../../config/columns';
import { clearBillings, getBillingsV2 } from '../../../../actions';

export const BillingSearchResult = ({
  loading,
  billings,
  dispatchClearBillings,
  dispatchGetBillingsV2,
  queryProps,
}) => {
  useLayoutEffect(() => () => dispatchClearBillings(), []);

  const data = billings.getIn(['page', 'content']) || [];
  const pages = billings.getIn(['page', 'totalPages']) || null;

  const totalPEN = billings.get('totalPEN') || 0;
  const totalUSD = billings.get('totalUSD') || 0;
  const totalEUR = billings.get('totalEUR') || 0;

  return (
    <div className="mt-3">
      <BillingTable
        columns={BILLING_COLUMNS}
        data={data}
        pages={pages}
        loading={loading}
        fetchData={dispatchGetBillingsV2}
        queryProps={queryProps}
      />

      <div className="mt-5 p-4 border-top bg-light rounded text-end">
        <h2 className="fw-bold mb-4 text-dark">Totales</h2>

        <h3 className="text-primary mb-3">
          Total Soles:{' '}
          <span className="fw-bold">
            {totalPEN.toLocaleString('es-PE', {
              style: 'currency',
              currency: 'PEN',
            })}
          </span>
        </h3>

        <h3 className="text-success mb-3">
          Total Dólares:{' '}
          <span className="fw-bold">
            {totalUSD.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
            })}
          </span>
        </h3>

        <h3 className="text-info">
          Total Euros:{' '}
          <span className="fw-bold">
            {totalEUR.toLocaleString('de-DE', {
              style: 'currency',
              currency: 'EUR',
            })}
          </span>
        </h3>
      </div>
    </div>
  );
};

const mapStateToProps = ({ AccountingUnit }) => ({
  loading: AccountingUnit.Billing.getIn(['all', 'loading']),
  billings: AccountingUnit.Billing.getIn(['all', 'content']),
});

const mapDispatchToProps = {
  dispatchClearBillings: clearBillings,
  dispatchGetBillingsV2: getBillingsV2,
};

BillingSearchResult.propTypes = {
  billings: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  dispatchClearBillings: PropTypes.func.isRequired,
  dispatchGetBillingsV2: PropTypes.func.isRequired,
  queryProps: PropTypes.arrayOf(PropTypes.string),
};

BillingSearchResult.defaultProps = {
  loading: false,
  queryProps: [],
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BillingSearchResult);
